import styled, { css } from 'styled-components'


interface PropsButton {
  size: "sm" | "lg";
  variant: string;
  tabIndex?: string;
}


export const Button = styled.button<PropsButton>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  &::before {
    z-index: 0;
    position: absolute;
    display: block;
    content:"";
    width: 100%;
    height: 100%;
    margin: 0;
    box-shadow: none;
    outline: none;
    opacity: 0;
    transform: scale(1);
    pointer-events: none;
    transition: opacity 0.250s, transform 0.2s;
    background-color: ${props => props.theme.states.hover.backgroundColor};
    border-radius: ${props => props.theme.button.borderRadius};
  }
  > * {
    z-index: 1;
  }
  &:hover:not(:disabled){
    &::before {
      opacity: 1;
      transform: scale(1);
      ${props => props.theme.states.hover}
    }
  }
  &:active:not(:disabled) {
    background-color: transparent;
    &::before{
      opacity: 1;
      transform: scale(0);
      transition: transform 0s, opacity 0s;
    }
  }

  &:disabled{
    cursor: auto;
    ${props => props.theme.states.disabled}
  }
  :focus-visible {
    ${props => props.theme.states.focus};
  }
  ${props => props.theme.button}
  ${props => props.theme.sizes[props.size]}
  ${props => props.theme.motion}
`

interface PropsNotification {
  disabled: boolean;
}

export const Notification = styled.span<PropsNotification>`
  display:block;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => props.theme.notification}
  ${props => props.disabled && css`
    ${props => props.theme.states.disabled.notification}
  `}
`